<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Papildomas laukas</h2>
      </v-card-title>

      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <el-text-field
                  label="Papildomo lauko pavadinimas"
                  :tooltip="tooltip"
                  :counter="100"
                  autofocus
                  v-model="newLaukas"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button
          primary
          @click.native.stop="saveData()"
          :disabled="!canSubmit"
        >
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPapildomasLaukas',
  props: {
    title: String,
    text: String,
    action: String,
    value: Boolean,
    tooltip: String,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      newLaukas: null,
    }
  },
  computed: {
    showTitle() {
      return this.title
    },
    canSubmit() {
      return true //this.newLaukas && this.newLaukas.length > 0
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return 'PapildomasLaukas'
    },
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit('confirm' + this.modalAction, this.newLaukas)
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.$emit('cancel' + this.modalAction)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      if (this.canSubmit) {
        this.saveData()
      }
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
